import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export const useUrlParamsQuery = (): URLSearchParams => {
  const location = useLocation();
  return useMemo( () => new URLSearchParams( location.search ), [location.search] );
};
